import React,{useState} from 'react'

function DHS({ receiverId, receiverName, onDataChange, errors = {} }) {
  const [dhsData, setDhsData] = useState({
    receiver_id: receiverId,
    receiver_name: receiverName,
  });
  // Allowed: letters, numbers, spaces. No special characters.
  const stripSpecialChars = (v) => (v ?? "").toString().replace(/[^A-Za-z0-9 ]/g, "");

  const handleInputChange = (field, value, el) => {
    const nextValue = stripSpecialChars(value);
    // Works with uncontrolled inputs (defaultValue) and also handles paste.
    if (el && el.value !== nextValue) {
      el.value = nextValue;
    }
    const next = { ...dhsData, [field]: nextValue };
    setDhsData(next);
    onDataChange(next);
  };

  return (
    <>
     <div style={{display:'grid',gridTemplateColumns: 'repeat(2, 1fr)',gap:'10px'}} >
     <div>
         <label className='require-field'>Receiver Name</label>
         <input
         type="text"
         className="form-control"
         autoComplete='off'
         id="receiver_name"
         defaultValue={receiverName}
         onChange={(e) => handleInputChange('receiver_name', e.target.value, e.target)}
         name="receiver_name"  />
         {errors.receiver_name && <span className='errors'>{errors.receiver_name}</span>}
    </div>
    <div>
         <label className='require-field'>Receiver Id</label>
         <input
         type="text"
         className="form-control"
         autoComplete='off'
         id="receiver_id"
         defaultValue={receiverId}
         onChange={(e) => handleInputChange('receiver_id', e.target.value, e.target)}
         name="receiver_id"  />
         {errors.receiver_id && <span className='errors'>{errors.receiver_id}</span>}
    </div>
     </div>
    </>
  )
}

export default DHS